/**
 * Basic TupasPage
 * Redirects when using HTML5 history api to the provided url.
 */
import {
    getProviders,
    startLoadingTupasProviders,
    IProvidersItem,
    IProvidersResponse,
} from "../../ducks/tupas";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect, Dispatch } from "react-redux";
import React from "react";
import { RouteProps, Redirect } from "react-router";
import { Typography, Button } from "material-ui";
import { Grid } from "material-ui";
import { SetHeader } from "../../ducks/common";
import logo from "kotibongari-logo.svg";
import { Link } from "react-router-dom";

/**
 * Props provided by redux
 */
interface ITupasErrorPageStateProps {}

/**
 * Dispatch functions provided by redux
 */
interface ITupasErrorPageDispatchProps {
    SetHeaderValue: (header: string) => void;
}

/**
 * Combined properties of the component
 */
type ITupasErrorPageProps = ITupasErrorPageStateProps &
    ITupasErrorPageDispatchProps &
    RouteProps;

const styles = {};

class TupasErrorPage extends React.Component<ITupasErrorPageProps> {
    constructor(props: ITupasErrorPageProps) {
        super(props);
    }

    componentWillMount() {
        this.props.SetHeaderValue("Tupas");
    }

    public render() {
        //TODO
        return <Redirect to={"/"} />;
    }
}

const mapStateToProps = (state: ReduxState): ITupasErrorPageStateProps => {
    return {
        //returnPath: getErrorReturnPath(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ITupasErrorPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TupasErrorPage);



// WEBPACK FOOTER //
// ./src/views/tupas/TupasErrorPage.tsx